import workspaceQuery from 'graphql/queries/system/SystemSystemUserWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/system/SystemSystemUserListQuery.graphql';
import instanceQuery from 'graphql/queries/system/SystemSystemUserQuery.graphql';
import defaultQuery from 'graphql/queries/system/SystemSystemUserDefault.graphql';
import mutationQuery from 'graphql/mutations/system/SystemSystemUserMutation.graphql';
import fragment from 'graphql/fragments/system/SystemUserFragment.graphql';

const SystemSystemUser = {
  type: 'SystemUser',
  title: 'Users',
  formTitle: 'User',
  formUrl: '/System/SystemUser/Details/',
  workspaceUrl: '/System/SystemUser/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'username',
  },
  fragment,
  screenReference: 'SYSTEM_USER',
  actions: [
    { actionReference: 'SYSTEM_USERS_ENABLE' },
    { actionReference: 'SYSTEM_USERS_DISABLE' },
    { actionReference: 'SYSTEM_USERS_SUPPORT_FUNC' },
    { actionReference: 'SYSTEM_USERS_CLEAR_LOGIN_DELAY' },
    { actionReference: 'SYSTEM_USERS_PASSWORD_RESET' },
  ],
};

export default SystemSystemUser;
